import React, { useState, useEffect, useMemo, useContext } from "react";
import {
  Grid,
  GridColumn,
  Segment,
  GridRow,
  Label,
  Table,
  Header,
  Button,
  Breadcrumb,
  Loader,
  Message,
  Icon,
  TableBody,
  TableRow,
  TableCell,
} from "semantic-ui-react";
import BatteryImage from "../SharingPoints/BatteryImage";
import { SimpleMap } from "../helpers/maps/SimpleMarkerMap";
import { Link, navigate } from "@reach/router";
import { useFormatTimestamp } from "../../hooks/use-format-timestamp";
import { isArray, upperFirst } from "lodash";
import { useSelector } from "react-redux";
import {
  BatteryIdDropdown,
  ExportDataAsCsv,
  SwapStateLabel,
  SWBLabel,
  SWBNavigateTo,
  swobbeeMainColor,
} from "../UtilComponents";
import "./style.scss";
import moment from "moment";
import { toast } from "react-toastify";
import { AxiosContext } from "../../context/AxiosContext";
export default ({ swapId }) => {
  const [swap, setSwap] = useState();
  const [colorMapping, setColorMapping] = useState();

  const { timeSpans } = useFormatTimestamp();

  const { user_group } = useSelector((state) => state.session);
  const { axiosInstance } = useContext(AxiosContext);

  const fetchSwapById = async () => {
    try {
      const { data } = await axiosInstance.get("/swap/" + swapId);
      setSwap(data.data);
    } catch (error) {
      toast.error(error.response.data.message);
      navigate("/statistics");
    }
  };

  const generateHexColor = () => {
    let temp = `#${Math.floor(Math.random() * 16777215).toString(16)}`;
    if (!colorMapping) return temp;
    while (!Object.values(colorMapping).includes(temp)) {
      temp = `#${Math.floor(Math.random() * 16777215).toString(16)}`;
    }
    return temp;
  };

  useEffect(() => {
    if (!swap) return;
    const temp = {};
    swap.events.forEach(({ battery_id }) => {
      temp[battery_id] = {
        color: generateHexColor(),
        count: temp[battery_id] ? temp[battery_id].count + 1 : 1,
      };
      setColorMapping(temp);
      console.log(temp);
    });
    console.log(colorMapping);
    return () => {
      setColorMapping(null);
    };
  }, [swap]);

  useEffect(() => {
    fetchSwapById();
  }, []);

  const convertTimestamp = (timestamp) => {
    let d = new Date(+timestamp);
    return (
      `${d.getDate()}.${d.getMonth() + 1}.${d.getFullYear()}` +
      " - " +
      d.getHours() +
      ":" +
      d.getMinutes() +
      ":" +
      d.getSeconds()
    );
  };

  const filename = `swap_export_${swapId}`;

  const data = useMemo(() => {
    if (!swap) return;
    if (!swap.events) return;
    return swap.events.map(
      ({
        action,
        battery_id,
        timestamp,
        module_number,
        slot_number,
        soc_value,
      }) => {
        return {
          module_number,
          slot_number,
          timestamp: convertTimestamp(timestamp),
          battery_id,
          state_of_charge: soc_value ? soc_value + "%" : "-",
          action,
        };
      }
    );
  }, [swap]);

  return (
    <Grid>
      {!swap && (
        <GridColumn width="16" style={{ marginTop: 60, marginLeft: 20 }}>
          <Loader active inline size="large" />
        </GridColumn>
      )}
      {swap && (
        <>
          <GridColumn width="16" style={{ marginTop: 60 }}>
            <Breadcrumb style={{ marginLeft: 20 }}>
              <Breadcrumb.Section link onClick={() => navigate("/")}>
                Home
              </Breadcrumb.Section>
              <Breadcrumb.Divider />
              <Breadcrumb.Section
                link
                onClick={() => navigate("/statistics?tab=swapTable")}
              >
                Statistics
              </Breadcrumb.Section>
              <Breadcrumb.Divider />
              <Breadcrumb.Section style={{ color: "#444" }}>
                {swapId}
              </Breadcrumb.Section>
            </Breadcrumb>
          </GridColumn>
          <GridRow columns="1">
            <GridColumn style={{ color: "black", height: "400px" }}>
              <Segment style={{ padding: 0, height: "400px" }}>
                <SimpleMap latLng={[+swap.gps_latitude, +swap.gps_longitude]} />
              </Segment>
            </GridColumn>
          </GridRow>
          <GridRow>
            <Grid
              stackable
              className="grid-swap-segment"
              style={{ marginTop: "200px", margin: "auto" }}
              columns="1"
            >
              <GridColumn style={{ color: "black" }}>
                <Segment>
                  <Grid>
                    <GridColumn
                      width="16"
                      style={{ margin: "auto" }}
                      textAlign="center"
                    >
                      <h3 style={{ color: "black" }}>
                        {`${swap.street} ${swap.street_number}, ${swap.zipcode} ${swap.city}`}
                      </h3>
                    </GridColumn>
                    <GridColumn
                      width="16"
                      textAlign="center"
                      style={{ marginTop: "14px", marginBottom: "14px" }}
                    >
                      <BatteryImage
                        type={swap.battery_type}
                        view={"swapView"}
                        width="auto"
                        height="150px"
                        float="middle"
                        margin="auto"
                      />
                    </GridColumn>
                    <GridColumn
                      style={{ display: "flex", flexDirection: "column" }}
                      width="8"
                    >
                      <div className="swap-detail-key-value-grid-flex">
                        <span className="swap-detail-view-key">
                          Sharingpoint
                        </span>{" "}
                        <span className="swap-detail-view-value">
                          <Link to={`/sharingpoints/${swap.sp_serial_number}`}>
                            {swap.sp_serial_number}
                          </Link>
                        </span>
                      </div>

                      <div className="swap-detail-key-value-grid-flex">
                        <span className="swap-detail-view-key">
                          Battery type
                        </span>{" "}
                        <span className="swap-detail-view-value">
                          {swap.battery_type}
                        </span>
                      </div>

                      <div className="swap-detail-key-value-grid-flex">
                        <span className="swap-detail-view-key">Requested</span>{" "}
                        <span className="swap-detail-view-value">
                          {swap.requested !== -1 ? (
                            swap.requested
                          ) : (
                            <Label
                              content={"FILL-IN"}
                              color="blue"
                              circular
                              style={{ width: 100 }}
                            />
                          )}
                        </span>
                      </div>

                      <div className="swap-detail-key-value-grid-flex">
                        <span className="swap-detail-view-key">Out/In</span>{" "}
                        <span className="swap-detail-view-value">
                          {swap.count_out}/{swap.count_in}
                        </span>
                      </div>

                      <div className="swap-detail-key-value-grid-flex">
                        <span className="swap-detail-view-key">Modules</span>
                        <span className="swap-detail-view-value">
                          {swap.swap_status_map
                            ? Object.keys(swap.swap_status_map).join(", ")
                            : "-"}
                        </span>
                      </div>
                    </GridColumn>

                    <GridColumn
                      style={{ display: "flex", flexDirection: "column" }}
                      width="8"
                    >
                      <div className="swap-detail-key-value-grid-flex">
                        <span className="swap-detail-view-key">State</span>{" "}
                        <span className="swap-detail-view-value">
                          <SwapStateLabel state={swap.state} />
                        </span>
                      </div>
                      <div className="swap-detail-key-value-grid-flex">
                        <span className="swap-detail-view-key">
                          Requested by
                        </span>{" "}
                        <span className="swap-detail-view-value">
                          <SWBNavigateTo
                            style={{ fontWeight: 16 }}
                            view="UserProfileView"
                            propId={swap.created_by}
                          />
                        </span>
                      </div>
                      <div className="swap-detail-key-value-grid-flex">
                        <span className="swap-detail-view-key">User group</span>
                        <span className="swap-detail-view-value">
                          {swap.swap_status_map ? swap.user_group_name.substring(0,35) : "-"}
                        </span>
                      </div>
                      <div className="swap-detail-key-value-grid-flex">
                        <span className="swap-detail-view-key">
                          Requested at
                        </span>{" "}
                        <span sclassName="swap-detail-view-value">
                          {timeSpans(swap.created_at, swobbeeMainColor, 16)}
                        </span>
                      </div>
                      <div className="swap-detail-key-value-grid-flex">
                        <span className="swap-detail-view-key">Updated at</span>{" "}
                        <span className="swap-detail-view-value">
                          {timeSpans(swap.updated_at, swobbeeMainColor, 16)}
                        </span>
                      </div>
                    </GridColumn>

                    {user_group === "overall_admin" && swap.is_cmcu && (
                      <>
                        <GridColumn width="16">
                          <Link
                            to={`/battery-tracking?swap_order_id=${swapId}`}
                          >
                            <Button
                              basic
                              content={"Track batteries by swap id"}
                              fluid
                            />
                          </Link>
                        </GridColumn>
                      </>
                    )}
                  </Grid>
                </Segment>
              </GridColumn>
              <GridColumn>
                <Segment>
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <Header style={{ color: "#444" }}>
                      {swap.door_events.length} Door events
                    </Header>
                  </div>
                  <Table>
                    <Table.Header>
                      <Table.Row>
                        <Table.HeaderCell className="left-header">
                          Event ID
                        </Table.HeaderCell>
                        <Table.HeaderCell className="inner-header">
                          Module
                        </Table.HeaderCell>
                        {swap.swap_type === "SINGLE_LOCK_SWAP" && (
                          <Table.HeaderCell className="inner-header">
                            Slot
                          </Table.HeaderCell>
                        )}

                        <Table.HeaderCell className="inner-header">
                          Timestamp
                        </Table.HeaderCell>

                        <Table.HeaderCell className="right-header">
                          State
                        </Table.HeaderCell>
                      </Table.Row>
                    </Table.Header>
                    <TableBody>
                      {swap.door_events.map(
                        ({
                          module_number,
                          door_state,
                          created_at,
                          event_id,
                          slot_number,
                        }) => (
                          <TableRow>
                            <TableCell>{event_id}</TableCell>
                            <TableCell>{module_number}</TableCell>
                            {swap.swap_type === "SINGLE_LOCK_SWAP" && (
                              <TableCell>{slot_number}</TableCell>
                            )}
                            <TableCell>
                              {moment(created_at).format("DD-MM-YYYY HH:mm:ss")}
                            </TableCell>
                            <TableCell>
                              <SWBLabel
                                content={door_state}
                                activated={door_state === "OPEN"}
                              />
                            </TableCell>
                          </TableRow>
                        )
                      )}
                    </TableBody>
                  </Table>
                  {!swap.door_events.length && (
                    <span style={{ alignSelf: "center", color: "#444" }}>
                      no data available
                    </span>
                  )}
                </Segment>
              </GridColumn>
              <GridColumn style={{ color: "black" }}>
                <Segment>
                  <Grid>
                    {swap && !swap.events.length && (
                      <GridColumn width={16}>
                        <Message icon="info">
                          <Message.List>
                            <Message.Item>
                              No relevant events available
                            </Message.Item>
                          </Message.List>
                        </Message>
                      </GridColumn>
                    )}

                    {user_group === "overall_admin" &&
                      swap.events &&
                      colorMapping &&
                      swap.events &&
                      isArray(swap.events) && (
                        <GridColumn width="16">
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <Header style={{ color: "#444" }}>
                              {swap.events.length} Battery events
                            </Header>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "flex-end",
                              }}
                            >
                              <ExportDataAsCsv {...{ data, filename }} />
                            </div>
                          </div>

                          <Table>
                            <Table.Header>
                              <Table.Row>
                                <Table.HeaderCell className="left-header">
                                  Module
                                </Table.HeaderCell>
                                <Table.HeaderCell className="inner-header">
                                  Slot
                                </Table.HeaderCell>

                                <Table.HeaderCell className="inner-header">
                                  Timestamp
                                </Table.HeaderCell>

                                {swap.is_cmcu && (
                                  <Table.HeaderCell className="inner-header">
                                    Battery id
                                  </Table.HeaderCell>
                                )}

                                {swap.is_cmcu && (
                                  <Table.HeaderCell className="inner-header">
                                    Soc
                                  </Table.HeaderCell>
                                )}
                                <Table.HeaderCell className="right-header">
                                  Action
                                </Table.HeaderCell>
                              </Table.Row>
                            </Table.Header>
                            <Table.Body>
                              {swap &&
                                swap.events &&
                                isArray(swap.events) &&
                                swap.events.map((item) => (
                                  <>
                                    {(!item.slot_value || item.slot_value) && (
                                      <Table.Row>
                                        <Table.Cell>
                                          {item.module_number}
                                        </Table.Cell>
                                        <Table.Cell>
                                          {item.slot_number}
                                        </Table.Cell>

                                        <Table.Cell>
                                          {moment(
                                            item.timestamp
                                              ? item.timestamp
                                              : item.created_at
                                          ).format("DD-MM-YYYY HH:mm:ss")}
                                        </Table.Cell>
                                        {swap.is_cmcu && (
                                          <Table.Cell textAlign="left">
                                            {swap.initial_serial_numbers.includes(
                                              item.battery_id
                                            ) ? (
                                              <>
                                                {colorMapping[item.battery_id]
                                                  .count > 1 && (
                                                  <Icon
                                                    name="circle"
                                                    style={{
                                                      color:
                                                        colorMapping[
                                                          item.battery_id
                                                        ].color,
                                                    }}
                                                  />
                                                )}
                                                <BatteryIdDropdown
                                                  isInitialBatteryId={swap.initial_serial_numbers.includes(
                                                    item.battery_id
                                                  )}
                                                  text={item.battery_id}
                                                  battery_id={item.battery_id}
                                                  battery_type={upperFirst(
                                                    swap.battery_type
                                                  )}
                                                />
                                              </>
                                            ) : (
                                              <>
                                                {colorMapping[item.battery_id]
                                                  .count > 1 && (
                                                  <Icon
                                                    name="circle"
                                                    style={{
                                                      color:
                                                        colorMapping[
                                                          item.battery_id
                                                        ].color,
                                                    }}
                                                  />
                                                )}
                                                <BatteryIdDropdown
                                                  isInitialBatteryId={swap.initial_serial_numbers.includes(
                                                    item.battery_id
                                                  )}
                                                  battery_id={item.battery_id}
                                                  battery_type={upperFirst(
                                                    swap.battery_type
                                                  )}
                                                />
                                              </>
                                            )}
                                          </Table.Cell>
                                        )}

                                        {swap.is_cmcu && (
                                          <Table.Cell>
                                            {item.swap_order_id === swapId
                                              ? ![null, undefined].includes(
                                                  item.battery_in_soc
                                                )
                                                ? item.battery_in_soc + "%"
                                                : "-"
                                              : ![null, undefined].includes(
                                                  item.soc_value
                                                )
                                              ? item.soc_value + "%"
                                              : "-"}
                                          </Table.Cell>
                                        )}

                                        <Table.Cell>
                                          <Label
                                            circular
                                            content={item.action}
                                            color={
                                              item.action === "IN"
                                                ? "green"
                                                : "red"
                                            }
                                            style={{ width: 40 }}
                                          />
                                        </Table.Cell>
                                      </Table.Row>
                                    )}
                                  </>
                                ))}
                            </Table.Body>
                          </Table>
                        </GridColumn>
                      )}
                  </Grid>
                </Segment>
              </GridColumn>
            </Grid>
          </GridRow>
        </>
      )}
    </Grid>
  );
};
